import * as React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { getActiveModalName, getActiveModalParams } from '../../redux/selectors/activeModal';
import { hideModal } from '../../redux/actions/activeModal.actions';
import { ModalName } from '../../types/ModalNames';
import EditTeamModal from './EditTeamModal/EditTeamModal';
import { RemoveFromTeam } from './RemoveFromTeam/RemoveFromTeam';
import DuplicateRoleModal from './DuplicateRole/DuplicateRoleModal';
import DiscardChangesModal from './DiscardChanges/DiscardChangesModal';
import { RemoveRole } from './RemoveRole/RemoveRole';
import EmptyRoleModal from './EmptyRole/EmptyRoleModal';
import TransferOwnershipModal from './TransferOwnership/TransferOwnership';
import { CannotRemoveRole } from './CannotRemoveRole/CannotRemoveRole';
import { LeaveTeam } from './LeaveTeam/LeaveTeam';
import ViewRolePermissions from './ViewRolePermissions/ViewRolePermissions';
import { Modal } from 'wix-style-react';
import ErrorModal from './ErrorModal/ErrorModal';
import EnforceContributorsUpgrade from './EnforceContributorsUpgrade/EnforceContributorsUpgrade';

interface IModalProps extends ConnectedProps<typeof connector> {}

class Modals extends React.Component<IModalProps> {
  render() {
    const { activeModalName, activeModalParams, closeModal } = this.props;
    return (
      <Modal
        dataHook={`modal_${activeModalName}`}
        isOpen={!!activeModalName}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick
      >
        {activeModalName === ModalName.EditTeamDetails && <EditTeamModal closeModal={closeModal}/>}
        {activeModalName === ModalName.RemoveFromTeam && <RemoveFromTeam
          closeModal={closeModal}
          idToRemove={activeModalParams.idToRemove}/>}
          {activeModalName === ModalName.LeaveTeam && <LeaveTeam
            closeModal={closeModal}
            idToRemove={activeModalParams.idToRemove}/>}
        {activeModalName === ModalName.RemoveRole && <RemoveRole
          closeModal={closeModal}
          idToRemove={activeModalParams.idToRemove}
          roleName={activeModalParams.roleName}
          onOk={activeModalParams.onOk}/>}
        {activeModalName === ModalName.DiscardChanges && <DiscardChangesModal
            onOk={activeModalParams.onOk}
            closeModal={closeModal}/>}
        {activeModalName === ModalName.DuplicateRole && <DuplicateRoleModal
            duplicateTitle={activeModalParams.duplicateTitle}
            onOk={activeModalParams.onOk}
            closeModal={closeModal}/>}
        {activeModalName === ModalName.EmptyRole && <EmptyRoleModal
            onOk={activeModalParams.onOk}
            closeModal={closeModal}/>}
        {activeModalName === ModalName.TransferOwnership &&
          <TransferOwnershipModal
          isOpen={activeModalName === ModalName.TransferOwnership}
          closeModal={closeModal}/>}
        {activeModalName === ModalName.CannotRemoveRole && <CannotRemoveRole
          closeModal={closeModal}
          {...activeModalParams}/>}
        {activeModalName === ModalName.ViewRolePermissions && <ViewRolePermissions
          roleTitle={activeModalParams.roleTitle}
          permissions={activeModalParams.permissions}
          onDuplicateAndEditAction={activeModalParams.onDuplicateAndEditAction}
          onEditAction={activeModalParams.onEditAction}
          closeModal={closeModal}/>}
        {activeModalName === ModalName.Error && <ErrorModal
          closeModal={closeModal} errorMessage={activeModalParams.errorMessage} title={activeModalParams.title}/>}
        {activeModalName === ModalName.EnforceContributorsUpgrade && <EnforceContributorsUpgrade
          closeModal={closeModal} shouldRedirectToMainPageOnClose={activeModalParams.shouldRedirectToMainPageOnClose} msid={activeModalParams.msid} contributorLimit={activeModalParams.contributorLimit} isFreePlan={activeModalParams.isFreePlan} origin={activeModalParams.origin}/>}
      </Modal>
    );
  }
}

const
  mapStateToProps = state => {
    return {
      activeModalName: getActiveModalName(state),
      activeModalParams: getActiveModalParams(state)
    };
  };

const connector = connect(mapStateToProps, { closeModal: hideModal });
export default connector(Modals);
